var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../../../../less/IdStyles";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { actionShowMeQuestTaskHaveExpansion } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskHaveExpansion = function (props) {
    var className = props.className, tasks = props.tasks, existingExpansionAmount = props.existingExpansionAmount, quest = props.quest, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var taskCompleted = existingExpansionAmount >= value.amount;
        var icon = React.createElement(Icon, { icon: IdIcon.ExpandFarmIcn, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: existingExpansionAmount,
            icon: icon,
            locaKey: value.locaKey,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: existingExpansionAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: function () { return onClickShowMe(value); }, questTask: value })));
    });
    return (React.createElement("div", { key: "haveExpansion", className: className }, list));
};
var mapState = function (state) {
    return {
        existingExpansionAmount: state.baseInfo.expansionIds.length,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskHaveExpansion,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskHaveExpansion = connect(mapState, mapDispatch)(_QuestTaskHaveExpansion);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskHaveExpansion/QuestTaskHaveExpansion.tsx
// module id = 2672
// module chunks = 3